import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ValidationHelper } from '../../helper/validation.helper';

@Component({
    selector: 'app-validation-messages',
    template: `
        <div class="alert alert-danger" [hidden]="!isWarning"> <em> Warning! </em> Please fill the required fields </div>
        <div class="alert alert-info" [hidden]="isWarning"> <em> Well Done! </em> the form is ready to submit </div>
   `,
})

export class ValidationMessageComponent implements AfterContentChecked, OnInit {
    @Input('form') form: FormGroup;
    @Input('isWarning') isWarning: boolean;

    constructor() { }

    ngOnInit() {
        this.validate();
    }

    ngAfterContentChecked() {
        this.validate();
    }

    validate() {
        this.isWarning = this.form ? !this.form.valid : this.isWarning;
    }
}
